import { Solicitante } from './../../models/solictante';
import { Injectable } from '@angular/core';
import { Pescador } from 'src/app/models/pescador';
import { HttpClient } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import 'rxjs/add/operator/map';

@Injectable({
  providedIn: 'root'
})
export class TablapescadoresService {
private pescador: Pescador;

  constructor(
    public http: HttpClient
  ) {
  }


  // getpescadores(idpescadores: string) {
  //   const url = URL_SERVICIOS + 'pescador/listados/:idsolicitante';
  //   return this.http.get ( url )
  //   .map ( (resp: any) => resp.pescador);
  // }


  getpescadores(idsolicitante: string) {
    const url = URL_SERVICIOS + '/pescador/' + idsolicitante;
    return this.http.get ( url )
     .map ( (resp: any) => resp.pescador);
  }



  getpescadorinventario(idultimoinventario: string) {
    const url = URL_SERVICIOS + '/pescador/inventariar/' + idultimoinventario;
    return this.http.get ( url );
  }


  // esta opcion unicamente pone en true el envio del reporte pdf en la tabla de pescador
  actualizemail(idsolicitante: string) {
    const url = URL_SERVICIOS + '/pescador/actualizaremail/' + idsolicitante;
    return this.http.get <Solicitante> ( url );
  }




  eleccionRealizadaCliente( id: string , idusuario: string) {
    const url = URL_SERVICIOS + '/seleccionado/' + id;
    let body = {
      seleccionado: idusuario

    };
    return this.http.put( url, body)
    .map ( (resp: any) => resp.ok);
  }

}
